<template>
    <div class="container">
        <div class="content" v-loading="loading">
            <div class="custom-tabs-con">
                <el-tabs v-model="activeSelectId" @tab-click="toggleTabs" class="custom-tabs2">
                    <el-tab-pane v-for="(item, index) of tabsList" :label="item.label" :name="item.id" :disabled="item.disabled" :key="index"></el-tab-pane>
                </el-tabs>
            </div>
            <!-- {{ activeSelectId }} -->
             <form-base-setting ref="baseSetting" :isProcess="true" v-show="activeSelectId === '1'" />
             <form-process-design ref="processDesign" :isProcess="true" v-show="activeSelectId === '2'"/>
             <form-pro-setting ref="proSetting" :isProcess="true" v-show="activeSelectId === '3'"/>
        </div>
        <transition name="el-fade-in">
          <div class="footer" v-show="footer" :class="[isCollapsed?'footer-collapsed':'']">
            <div class="footer-btn-b" @click="$router.go(-1)">返回</div>
            <div class="footer-btn-r" @click="tabsPage('prve')" v-if="activeSelectId !== '1'">上一步</div>
            <div class="footer-btn-r" @click="tabsPage('next')"  v-if="activeSelectId !== '3'">下一步</div>
            <div class="footer-btn-s" @click="validateDesign()">发布</div>
          </div>
        </transition>
        <!-- :status="step.status" -->
        <w-dialog :showFooter="false" v-model="validVisible" title="设置项检查">
            <el-steps align-center :active="validStep" finish-status="success" class="design-steps">
                <el-step v-for="(step, i) in validOptions" :title="step.title" :key="i"
                        :icon="step.icon" :status="step.status" :description="step.description"/>
            </el-steps>
            <el-result :icon="validIcon" :title="errTitle" :subTitle="validResult.desc" class="result-con">
                <i slot="icon" style="font-size: 30px" v-if="!validResult.finished" class="el-icon-loading"></i>
                <div slot="subTitle" class="err-info" v-if="validResult.errs && validResult.errs.length > 0">
                <ellipsis hover-tip v-for="(err, i) in validResult.errs" :key="i + '_err'" :content="err">
                    <i slot="pre" class="el-icon-warning-outline"></i>
                </ellipsis>
                </div>
                <template slot="extra">
                <el-button type="primary" class="btn-submit" v-if="validResult.finished" size="large" @click="doAfter" :loading="loading">
                    {{ validResult.action }}
                </el-button>
                </template>
            </el-result>
        </w-dialog>
    </div>
</template>

<script>
import FormBaseSetting from '@/pages/officeApproval/components/FormBaseSetting'
import FormProcessDesign from '@/pages/officeApproval/components/FormProcessDesign'
import FormProSetting from '@/pages/officeApproval/components/FormProSetting'
export default {
    name: 'addApproval',
    components: {
        FormBaseSetting,
        FormProcessDesign,
        FormProSetting
    },
    data() {
        return {
            tabsList: [
                { label: '1.基础配置', id: '1', value: 'baseSetting' },
                { label: '2.流程设计', id: '2', value: 'processDesign' },
                { label: '3.高级设置', id: '3', value: 'proSetting' },
            ],
            parArray: [],
            // activeSelect: 'baseSetting',
            activeSelectId:'1',
            isNew: true,
            validStep: 0,
            timer: null,
            validVisible: false,
            id: '',
            validResult: {},
            validOptions: [
                {title: '基础配置', description: '', icon: '', status: ''},
                {title: '流程设计', description: '', icon: '', status: ''},
                {title: '高级设置', description: '', icon: '', status: ''}
            ],
            validComponents: ['baseSetting', 'processDesign', 'proSetting'],
            loading: false,
            footer :false,
        }
    },
    computed: {
        setup() {
            return this.$store.state.design
        },
        errTitle(){
            if (this.validResult.finished && !this.validResult.success){
                return this.validResult.title + ` (${this.validResult.errs.length}项错误) `
            }
            return this.validResult.title
        },
        validIcon() {
            if (!this.validResult.finished) {
                return 'el-icon-loading'
            } else if (this.validResult.success) {
                return 'success'
            } else {
                return 'warning'
            }
        },
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    created() {
      
      // let group = this.$route.query.group
      // this.setup.groupId = this.$isNotEmpty(group) ? parseInt(group) : null
      // 权限设定判断 normsCode
      // this.limits = JSON.parse(sessionStorage.getItem("limit"))
      // const params = this.limits.buttonTreeDto.find(
      //     (item) => item.menuCode === "roster"
      // )
      // params.buttonList.forEach((item) => {
      //     this.parArray.push(item.code)
      // })
    },
    activated() {
        this.initData()
    },
    beforeDestroy() {
        this.stopTimer()
    },
    mounted() {
        
    },
    methods: {
      initData() {
        this.showValiding()
        this.id = this.$route.query.id
        //判断传参，决定是新建还是加载原始数据
        this.loadInitFrom()
        if (this.id) {
            this.isNew = false
            this.fecthFormDetail(this.id)
        }else{
          this.$store.commit('updatesSelectFormItem', null)
        }
        setTimeout(()=>{
              this.footer = true
        },500)
      },
      fecthFormDetail(id) {
        this.loading = true
        const postData = {
          id
        }
        this.$api.workflowTemplateDetail(postData).then(res => {
          // console.log(res.data)
          
          let form = res.data;
          form.settings = JSON.parse(form.settings)
          form.formItems = JSON.parse(form.formItems)
          form.process = JSON.parse(form.process)
          form.whoCommit = JSON.parse(form.whoCommit)
          this.$store.commit('loadForm', form)
          console.log('设置>>',res.data.settings)
          // console.log('高级>>',res.data.settings.timeLimitedApproval)
          // 打开页面时，如何有数据，默认选中第一个
          if (form.formItems &&  form.formItems.length > 0) {
            this.$store.commit('updatesSelectFormItem', form.formItems[0])
          }
          this.loading = false
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      },
        // 下一步
        tabsPage(type){
            let id
            if(type === 'next'){
                id = +this.activeSelectId + 1
            }else{
                id = +this.activeSelectId - 1
            }
            this.activeSelectId = String(id)
        //    const item = this.tabsList.find(item => item.id === String(id))
        //    console.log('>>',id,item) 
        //    this.toggleTabs(item)
        },
        toggleTabs(e) { 
            // console.log(e.name)
            if(e.name === 'processDesign'){
                this.$nextTick(()=>{
                    // console.log('>>',this.$refs.processDesign.insertNode('APPROVAL'))

                    console.log('>>',this.$refs.processDesign)
                })
            }    
        },
        loadInitFrom() {
            const ApprovalId = this.getRandomId()
            const taskId = this.getRandomId()
            const ccId = this.getRandomId()
            this.$store.commit('loadForm', {
                id: null,
                templateName: "",
                settings: {
                    commiter: [],
                    admin: [],
                    sign: false,
                    autoDeduplicationSettings:{
                      enable:true,
                      sameApproverMultipleTimes:{
                        enable:false,
                        strategy:'deduplicateConsecutive'
                      },
                      approverIsInitiator:false
                    },
                    allowAddApprovers:true,
                    allowRevocation:true,
                    timeLimitedApproval:{
                      enable:false,
                      timeoutAction:'autoApprove',
                      timeoutHours:'24'
                    },
                    notificationSettings:{
                      enable:true,
                      onRejectionNotifyAllBeforeRejection:true,
                      onRejectionNotifyOtherOrSignApprovers:true,
                      onRejectionNotifyOtherAndSignApprovers:true,
                      onApprovalNotifyOtherOrSignApprovers:true
                    }
                    
                },
                groupId: undefined,
                formItems: [],
                process: {
                    id: "root",
                    parentId: null,
                    type: "ROOT",
                    name: "发起人",
                    desc: "任何人",
                    props: {
                        assignedUser: [],
                        formPerms: []
                    },
                    children: {
                      children: {
                        children: {
                          id:ccId,
                          children:undefined,
                          name:"抄送人",
                          parentId:taskId,
                          props:{
                            assignedType:"ASSIGN_USER",
                            assignedUser:[],
                            formPerms:[],
                            shouldAdd:false,
                            role:[],
                            leader:{
                              level:1
                            },
                            leaderTop:{
                              endCondition:"TOP",
                              endLevel:1
                            },
                          },
                          type:"CC",
                        },
                        id:taskId,
                        name:'办理人',
                        parentId:ApprovalId,
                        type:"TASK",
                        props:{
                          assignedType:"ASSIGN_USER",
                          assignedUser:[],
                          formPerms:[],//表单权限
                          formUser:'',
                          leader:{
                            level:1
                          },
                          leaderTop:{
                            endCondition:"TOP",
                            endLevel:1
                          },
                          mode:"AND",
                          nobody:{
                            assignedUser:[],
                            handler:"TO_ADMIN",
                          },
                          refuse:{
                            target:"",
                            type:"TO_END"
                          },
                          role:[],
                          selfSelect:{
                            multiple:false
                          },
                          sign:false,
                          timeLimit:{
                            handler:{
                              notify:{
                                hour:1,
                                once:true,
                              },
                              type:"REFUSE"
                            },
                            timeout:{
                              unit:"H",
                              value:0
                            }
                          },
                        },
                      },
                      id:ApprovalId,
                      name:'审批人',
                      parentId:"root",
                      type:"APPROVAL",
                      props:{
                        assignedType:"ASSIGN_USER",
                        assignedUser:[],
                        formPerms:[],//表单权限
                        formUser:'',
                        leader:{
                          level:1
                        },
                        leaderTop:{
                          endCondition:"TOP",
                          endLevel:1
                        },
                        mode:"AND",
                        nobody:{
                          assignedUser:[],
                          handler:"TO_ADMIN",
                        },
                        refuse:{
                          target:"",
                          type:"TO_END"
                        },
                        role:[],
                        selfSelect:{
                          multiple:false
                        },
                        sign:false,
                        timeLimit:{
                          handler:{
                            notify:{
                              hour:1,
                              once:true,
                            },
                            type:"REFUSE"
                          },
                          timeout:{
                            unit:"H",
                            value:0
                          }
                        },
                        
                      },

                    }
                },
                remark: ""
            })
        },
        getRandomId(){
          return `node_${new Date().getTime().toString().substring(5)}${Math.round(Math.random()*9000+1000)}`
        },
    validateDesign() {
      console.log('000')
      this.validVisible = true
      this.validStep = 0
      this.showValiding()
      this.stopTimer()
      this.timer = setInterval(() => {
        this.validResult.errs = this.$refs[this.validComponents[this.validStep]].validate()
        console.log('>>',this.validResult.errs)
        if (Array.isArray(this.validResult.errs) && this.validResult.errs.length === 0) {
          this.validStep++;
          if (this.validStep >= this.validOptions.length) {
            this.stopTimer()
            this.showValidFinish(true)
          }
        } else {
          this.stopTimer()
          this.validOptions[this.validStep].status = 'error'
          this.showValidFinish(false, this.getDefaultValidErr())
        }
      }, 200)
    },
    getDefaultValidErr() {
      switch (this.validStep) {
        case 0:
          return '请检查基础配置';
        case 1:
          return '请检查表单设置'
        case 2:
          return '请检查流程设计，查看对应标注节点错误信息'
        case 3:
          return '请检查高级设置'
        default:
          return '未知错误'
      }
    },
    showValidFinish(success, err) {
      this.validResult.success = success
      this.validResult.finished = true
      this.validResult.title = success ? '校验完成' : '校验失败'
      this.validResult.desc = success ? '设置项校验成功，是否提交？' : err
      this.validResult.action = success ? '提 交' : '去修改'
    },
    showValiding() {
      this.validResult = {
        errs: [],
        finished: false,
        success: false,
        title: '检查中...',
        action: '处理',
        desc: '正在检查设置项'
      }
      this.validStep = 0
      this.validOptions.forEach(op => {
        op.status = ''
        op.icon = ''
        op.description = ''
      })
    },
    doAfter() {
      if (this.validResult.success) {
        this.doPublish()
      } else {
        this.activeSelectId = String(+this.validStep + 1)
        // this.activeSelect = this.validComponents[this.validStep]
        this.validVisible = false
      }
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    updateFormPerms(form, form2) {
      function traverse(node) {
        // 处理当前节点的 formPerms
        if (node && node.props && Array.isArray(node.props.formPerms)) {
          for (const item of form) {
            const exists = node.props.formPerms.some(f => f.id === item.id);
            if (!exists) {
              const newItem = {
                id: item.id,
                title: item.title,
                required: item.props.required || false,
                icon: item.icon,
                perm: (item.icon === 'icon-shuoming' || item.icon === 'icon-ruzhi')  ? 'R' : (node.id === 'root' ? 'E' : 'R')
              };
              node.props.formPerms.push(newItem);
            }
          }
        }

        // 递归处理子节点
        if (node.children) {
          traverse(node.children); // 不再传递 parentId，直接使用 node.id 判断
        } else if (node.type === 'ROOT' && node.children && node.children.children) {
          let current = node.children;
          while (current) {
            traverse(current);
            current = current.children;
          }
        }
      }

      traverse(form2);
    },
    doPublish() {
      
      this.$refs.baseSetting.templateNameError=''
    //   this.$confirm('如果您只想预览请选择预览，确认发布后流程立即生效，是否继续?', '提示', {
    //     confirmButtonText: '发布',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
        console.log(this.setup)
        let processNew =  JSON.parse(JSON.stringify(this.setup.process));
         // 修改的的时候需要把process.props.assignedUser 一起改,whoCommit等于assignedUser
         processNew.props.assignedUser = this.setup.whoCommit
        //判断条件分支
        this.conditionRecursion(processNew);
         // 设置表单的默认权限
         this.updateFormPerms(this.setup.formItems,processNew)
        //  console.log('template>>',this.setup.formItems,processNew)
        //  console.log('>>',JSON.stringify(this.setup.formItems))
        //  console.log('>>',JSON.stringify(processNew))
        let template = {
          id: this.setup.id,
          templateName: this.setup.templateName,
          // logo: JSON.stringify(this.setup.logo),
          settings: JSON.stringify(this.setup.settings),
          groupId: this.setup.groupId,
          formItems: JSON.stringify(this.setup.formItems),
          process: JSON.stringify(processNew),
          remark: this.setup.remark,
          whoCommit: JSON.stringify(this.setup.whoCommit),
        }
       
        console.log('template>>',processNew)
        // return
        this.loading = true
        if (this.isNew || !this.$isNotEmpty(this.setup.id)) {
            console.log('createForm>>',template)
            this.$api.workflowNew(template).then(rsp => {
            if (rsp.code == 0) {
              this.$message.success("已创建")
              this.$router.push("/officeApproval/processManagement")
              this.$refs.baseSetting.templateNameError = ''
              this.validVisible = false
            }else if (rsp.code === 103) {
              this.activeSelectId = '1'
              this.validVisible = false
              this.$nextTick(()=>{
                this.$refs.baseSetting.templateNameError = rsp.message
              })
            }
          }).catch(err => {
            this.$message.error(err)
          }).finally(()=>{
            this.loading = false
          })
        } else {
          this.$api.workflowUpdate(template).then(rsp => {
            if (rsp.code == 0) {
              this.$message.success("已更新")
              this.$router.push("/officeApproval/processManagement")
              this.$refs.baseSetting.templateNameError = ''
              this.validVisible = false
            }else if (rsp.code === 103) {
              this.activeSelectId = '1'
              this.validVisible = false
              this.$nextTick(()=>{
                this.$refs.baseSetting.templateNameError = rsp.message
              })
            }
          }).catch(err => {
            this.$message.error(err)
          }).finally(()=>{
            this.loading = false
          })
        }
    //   })
    },
    conditionRecursion(process){
      if(null != process && undefined != process){
        if(null != process.branchs && undefined != process.branchs){
          process.branchs.map((item, i) => {
            if (i == process.branchs.length - 1) {
              item.typeElse = true;
            } else {
              item.typeElse = false;
            }
            if(null != item.children && undefined != item.children){
              this.conditionRecursion(item.children)
            }else{
              return item;
            }
          });
        }
        this.conditionRecursion(process.children)
      }
    }
    }
}
</script>
<style scoped lang="scss">
.container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .content {
        width: 100%;
        min-height: calc(100vh - 202px);
        margin-top: 16px;
        background-color: white;
        padding-left: 16px;
        padding-left: 16px;
        box-sizing: border-box;
        padding-top: 32px;
        border-radius: 8px 8px 0 0;

        .custom-tabs-con {
            position: relative;
            height: 39px;
            overflow: hidden;

            &::after {
                content: '';
                position: absolute;
                height: 1px;
                background-color: #EDF2F2;
                width: 100%;
            }

            &::after {
                bottom: 0;
                left: 0;
                right: 0;
            }
        }

        .custom-tabs2 {
            margin: 0 auto;
            width: 342px;
            /deep/ .el-tabs__item{
                width: auto;
            }
        }



    }

    .footer {
      height: 84px;
      background: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      left: 200px;
      right: 0;
      bottom: 0;
      border-top: 1px solid #EDF2F2;
      box-sizing: border-box;
      transition: left 0.3s ease-in-out;
      z-index: 2;

          .footer-btn-b {
              width: 88px;
              height: 36px;
              background: #EDF2F2;
              border-radius: 4px 4px 4px 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #939696;
              line-height: 36px;
              text-align: center;
              margin-right: 16px;
              cursor: pointer;
          }

          .footer-btn-r {
              width: 88px;
              height: 36px;
              background: #FFFFFF;
              border-radius: 4px 4px 4px 4px;
              border: 1px solid #00B498;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #00B498;
              line-height: 36px;
              text-align: center;
              margin-right: 16px;
              cursor: pointer;
          }

          .footer-btn-s {
              width: 88px;
              height: 36px;
              background: #00B498;
              border-radius: 4px 4px 4px 4px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #FFFFFF;
              line-height: 36px;
              text-align: center;
              cursor: pointer;
          }
    }
    .footer-collapsed {
      left: 80px;
    }

}
.result-con{
    padding:20px 0 0;
    .btn-submit{
        width: 200px;
    }
}
.design-steps {
  /deep/{
    .el-step__head.is-success{
      color: #00B498;
      border-color: #00B498;
    }
    .el-step__title.is-success{
      color: #00B498;
    }
    .el-step__head.is-process{
      color: #2F3030;
      border-color: #2F3030;
    }
    .el-step__title.is-process{
      color: #2F3030;
    }
  }
}
</style>